import type sv from '../sv/meet'

const meet: typeof sv = {
  disabled: {
    title: 'Video meetings are not enabled',
    description:
      'HUB video meetings are not turned on for your organization. An administrator can enable them.',
    back: 'Back to the project',
  },
  loading: 'Connecting to the meeting…',
  reconnecting: 'Reconnecting to the meeting…',
  ongoing: {
    title: 'Ongoing meeting',
    live: 'Live',
    reconnecting: 'Reconnecting',
    return: 'Return to meeting',
  },
  leaveProject: {
    title: 'Leave the meeting?',
    description:
      'You will leave the meeting if you switch project. The meeting goes on for the others, and you can rejoin from the calendar.',
    cancel: 'Stay',
    confirm: 'Leave the meeting',
  },
  notFound: {
    title: 'Meeting not found',
    description: 'The link is wrong, or the meeting belongs to another project.',
    back: 'Back to the calendar',
  },
  notConfigured: {
    title: 'Video meetings are not configured',
    description: 'This environment has no RealtimeKit settings. Contact an administrator.',
  },
  prejoin: {
    title: 'Ready to join?',
    cameraOff: 'Camera is off',
    permissionDenied:
      'HUB was not given access to your microphone or camera. You can join anyway and turn them on later.',
    cameraDenied:
      'HUB was not given access to your camera. You can join anyway and turn it on later.',
    microphoneDenied:
      'HUB was not given access to your microphone. You can join anyway and turn it on later.',
    microphone: 'Microphone',
    camera: 'Camera',
    join: 'Join',
    joining: 'Joining…',
    cancel: 'Cancel',
  },
  waiting: {
    title: 'The meeting has not started yet',
    opensIn: 'You can join in {{time}}',
    openingNow: 'Opening now…',
    retry: 'Try again',
    notes: 'Open the meeting notes',
  },
  ended: {
    title: 'The meeting has ended',
    host: 'The host ended the meeting.',
    idle: 'The meeting ended because nobody was left.',
    cap: 'The meeting ended after six hours.',
    rtk: 'The meeting ended.',
    deleted: 'The meeting was deleted.',
    notesPending: 'The meeting notes are being finished…',
    notes: 'Open the meeting notes',
    back: 'Back to the calendar',
  },
  controls: {
    micOn: 'Mute the microphone',
    micOff: 'Unmute the microphone',
    cameraOn: 'Turn the camera off',
    cameraOff: 'Turn the camera on',
    shareOn: 'Stop sharing your screen',
    shareOff: 'Share your screen',
    panelOn: 'Hide the live panel',
    panelOff: 'Show the live panel',
    participants_one: '{{count}} participant',
    participants_other: '{{count}} participants',
    leave: 'Leave',
    end: 'End meeting',
    micShortcut: 'Press M to mute or unmute',
    raiseHand: 'Raise your hand',
    lowerHand: 'Lower your hand',
    pauseTranscription: 'Pause transcription — HUB stops listening',
    resumeTranscription: 'Resume transcription',
  },
  endDialog: {
    title: 'End the meeting for everyone?',
    description:
      'Every participant is disconnected and HUB finishes the meeting notes. This cannot be undone.',
    cancel: 'Cancel',
    confirm: 'End meeting',
  },
  banner: {
    pausedByHost: 'Transcription paused — HUB is not listening',
    pausedByCredits: 'Transcription paused — out of credits',
    resume: 'Resume',
  },
  participants: {
    title_one: '{{count}} participant',
    title_other: '{{count}} participants',
    active: 'In the call',
    connected: 'Connected',
    left: 'Left',
  },
  hands: {
    title_one: '{{count}} raised hand',
    title_other: '{{count}} raised hands',
    raised: '{{name}} raised a hand',
    lower: 'Lower',
  },
  devices: {
    microphone: 'Microphone',
    camera: 'Camera',
    choose: 'Choose {{kind}}',
  },
  dock: {
    title_one: '{{count}} participant',
    title_other: '{{count}} participants',
    speaking: 'Speaking',
    handRaised: 'Hand raised',
    collapse: 'Collapse the video dock',
    expand: 'Expand the video dock',
    you: 'You',
    muted: 'Microphone muted',
    screenShare: 'Sharing their screen',
    expandShare: 'Show the screen share larger',
    closeShare: 'Close',
  },
  share: {
    viewing: '{{name}} is sharing their screen',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    fit: 'Fit',
    minimize: 'Minimize',
    title: 'You are sharing your screen',
    stop: 'Stop sharing',
  },
  panel: {
    title: 'Live',
    transcript: 'Transcript',
    summary: 'Summary',
    empty: 'Nothing said yet.',
    noSummary: 'The summary is written after a minute.',
    decisions: 'Decisions',
    actions: 'Action items',
  },
  errors: {
    joinFailed: 'Could not join the meeting.',
    mediaFailed: 'Could not start the camera or microphone.',
    microphoneBlocked:
      'Your microphone is blocked — nobody can hear you. Check your browser permissions.',
    outOfCredits: 'Out of credits. An administrator can raise the limit.',
    retry: 'Try again',
  },
}

export default meet
